import { render, staticRenderFns } from "./DepositSubmission.vue?vue&type=template&id=91499298&scoped=true"
import script from "./DepositSubmission.vue?vue&type=script&lang=js"
export * from "./DepositSubmission.vue?vue&type=script&lang=js"
import style0 from "./DepositSubmission.vue?vue&type=style&index=0&id=91499298&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91499298",
  null
  
)

export default component.exports